import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TransferPricingOnboardingInformation } from './types';

export function useTransferPricingOnboardings(companyId: number) {
  const URL = companyId
    ? `transfer-pricing/onboarding?companyId=${companyId}`
    : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: {
      onboardings: TransferPricingOnboardingInformation[];
      count: number;
    };
    error: unknown;
    mutate: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    URL,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
    isLoading,
  };
}
